import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AuthContextService } from '../services/auth-context.service';
import { CognitoServiceService } from '../services/cognito-service.service';
import { CorrelationService } from '../services/correlation.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authContextService = inject(AuthContextService);
  const correlationService = inject(CorrelationService);
  const cognitoService = inject(CognitoServiceService);
  const isCognitoTokenRequest = req.url.includes('/oauth2/token');

  let cloned = req;

  console.warn('[authInterceptor] hit', {
    method: cloned.method,
    url: cloned.url
  });

  if (authContextService.hasInternalAccess && cloned.url.includes('/dashboard/embedURL')) {
    cloned = cloned.clone({
      url: cloned.url.replace('/dashboard/embedURL', '/internal/dashboard/embedURL')
    });
  }

  if (authContextService.hasInternalAccess && cloned.url.includes('user/s3-presigned')) {
    cloned = cloned.clone({
      url: cloned.url.replace('/user/s3-presigned', '/internal/user/s3-presigned')
    });
  }

  if(authContextService.hasInternalAccess && cloned.url.includes('/user/subscriptions')) {
    cloned = cloned.clone({
      url: cloned.url.replace('/user/subscriptions', '/internal/user/subscriptions')
    });
  }

  if(authContextService.hasInternalAccess && cloned.url.includes('/user/s3Reports')) {
    cloned = cloned.clone({
      url: cloned.url.replace('/user/s3Reports', '/internal/user/s3Reports')
    });
  }

  if (authContextService.hasInternalAccess && cloned.url.includes('/user/settings')) {
    cloned = cloned.clone({
      url: cloned.url.replace('/user/settings', '/internal/user/settings')
    });
  }

  if(authContextService.hasInternalAccess && cloned.url.includes('/report-params')) {
    cloned = cloned.clone({
      url: cloned.url.replace('/report-params', '/internal/report-params')
    });
  }

  if(authContextService.hasInternalAccess && cloned.url.includes('/user/feature-flags')) {
    cloned = cloned.clone({
      url: cloned.url.replace('/user/feature-flags', '/internal/user/feature-flags')
    });
  }

  if(authContextService.hasInternalAccess && cloned.url.includes('/user/guides')) {
    cloned = cloned.clone({
      url: cloned.url.replace('/user/guides', '/internal/user/guides')
    });
  }

  if (authContextService.hasInternalAccess && cloned.url.includes('/user/session/invalidate')) {
    cloned = cloned.clone({
      url: cloned.url.replace('/user/session/invalidate', '/internal/user/session/invalidate')
    });
  }

  if (authContextService.hasInternalAccess && cloned.url.includes('/user/reports/export')) {
    cloned = cloned.clone({
      url: cloned.url.replace('/user/reports/export', '/internal/user/reports/export')
    });
  }

  if (authContextService.hasInternalAccess && cloned.url.includes('/user/report-builder')) {
    cloned = cloned.clone({
      url: cloned.url.replace('/user/report-builder', '/internal/user/report-builder')
    });
  }

  if (isCognitoTokenRequest) {
    return next(cloned);
  }

  return cognitoService.ensureValidIdToken(30).pipe(
    switchMap((isTokenValid) => {
      if (!isTokenValid) {
        return throwError(() => new HttpErrorResponse({
          status: 401,
          statusText: 'Unauthorized',
          error: 'Unable to refresh ID token'
        }));
      }

      const token = sessionStorage.getItem('token');
      const idToken = sessionStorage.getItem('id_token');

      if (token || idToken) {
        const headers: Record<string, string> = {};
        headers['x-api-key'] = environment.apiKey;
        if (token) {
          headers['Authorization'] = token;
        }
        if (idToken) {
          headers['id_token'] = idToken;
        }
        // Use report session correlationId if available, otherwise generate a per-request fallback
    const correlationId = correlationService.get()
      ?? `${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
    headers['X-Correlation-ID'] = correlationId;
    cloned = cloned.clone({
          setHeaders: headers
        });
      }

      return next(cloned);
    })
  );
};